export const URL_GET_MERCHANT_WALLETS = `/merchant-wallets%(params)s`;
export const URL_GET_MERCHANT_WALLETS_REPORT = `/merchant-wallets/reports%(params)s`;
export const URL_GET_HOME_PROPERTY = `/home`;
export const URL_GET_NOTIFICATION = `/notifications%(params)s`;
export const URL_READ_NOTIFICATION = `/notifications/%(id)s`;
export const URL_GET_UNREAD_NOTIFICATION = `/notifications/unread-count`;
export const URL_READ_ALL_NOTIFICATION = `/notifications/mark-all-read`;
export const URL_GET_MERCHANT_BANKS = `/merchant-banks`;
export const URL_GET_INITIALIZER = `/utility/initializers`;
